import { t } from '@lingui/core/macro';
import { NoddiInfoBanner } from 'noddi-ui-web';

export const ProposalNotConfirmedBanner = () => (
  <NoddiInfoBanner
    variant='info'
    title={t`This is not a confirmed booking`}
    texts={[
      {
        value: t`We've prepared this booking for you so it's easy to confirm. Just review the details and confirm when you're ready — it won't be active until you do.`
      }
    ]}
  />
);
